import React from 'react';
export const useOnVideoStopCallback = () => React.useCallback((video) => {
    const img = video?.nextElementSibling;
    if (img) {
        video.style.opacity = '0';
        img.style.opacity = '1';
    }
}, []);
//# sourceMappingURL=useOnVideoStopCallback.js.map